module.exports = __webpack_public_path__ + "static/media/BlueWhite_HousingAuthoritylogo.9903c7fb.svg";